if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super()
      this.cart =
        document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      this.isSubmitting = false
    }

    connectedCallback() {
      this.init()
    }

    init() {
      this.submitButton = this.querySelector('[type="submit"]')
      this.form = this.querySelector('form.js-product-form')
      this.productInfo = this.closest('product-info')
      if (!this.productInfo) {
        this.productInfo = this.closest('quick-add-product-info')
      }
      if (!this.productInfo) return
      if (!this.form) return
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))

      this.addEventListener('click', (e) => {
        if (
          this.submitButton.disabled &&
          this.productInfo.querySelector('variant-selects input:checked') === null
        ) {
          this.productInfo.querySelector('variant-selects').classList.add('highlight-me')
          setTimeout(
            () =>
              this.productInfo.querySelector('variant-selects').classList.remove('highlight-me'),
            500,
          )
        }
      })
    }

    async onSubmitHandler(evt) {
      evt.preventDefault()
      if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.isSubmitting) return

      this.isSubmitting = true
      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.classList.add('loading')
      this.querySelector('.loading__spinner').classList.remove('hidden')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)

      let quantity = 1
      let packSize = ''
      const insiderClubUpsell = this.productInfo.querySelector('#insider-club-upsell')

      if (this.productInfo) {
        quantity = this.productInfo.querySelector('select[name="quantity"]')?.value // Used for data layer
        packSize = this.productInfo.dataset.productPackSize

        formData.append(
          'properties[_cart_source]',
          this.productInfo.dataset.pageType === 'bundle builder'
            ? 'AMSM'
            : packSize === 'Single'
              ? 'PDP Singles'
              : 'PDP Curated Pack',
        )

        formData.append(
          'properties[_style_number]',
          this.productInfo.dataset.styleNumber ? this.productInfo.dataset.styleNumber : '',
        )

        formData.append(
          'properties[_sku_id]',
          this.productInfo.dataset.sku ? this.productInfo.dataset.sku : '',
        )

        formData.append(
          'properties[_variant_id]',
          this.productInfo.dataset.variantId ? this.productInfo.dataset.variantId : '',
        )

        // For testing purposes
        if (
          window['axgy-variant'] === true &&
          this.productInfo.dataset.productClearance === 'false'
        ) {
          formData.append('properties[_value_builder]', 'true')
        }

        if (insiderClubUpsell && insiderClubUpsell.checked) {
          // Replace `properties[key]` with `item[0][properties][key]` for Shopify's add to cart event to trigger properly
          const propertiesToDelete = []
          const propertiesToAppend = []
          for (const pair of formData.entries()) {
            if (pair[0].indexOf('properties') === 0) {
              propertiesToDelete.push(pair[0])
              propertiesToAppend.push({
                key: pair[0].replace('properties', 'items[0][properties]'),
                value: pair[1],
              })
            } else if (pair[0].indexOf('id') === 0) {
              propertiesToDelete.push(pair[0])
              propertiesToAppend.push({
                key: 'items[0][id]',
                value: pair[1],
              })
            } else if (pair[0].indexOf('quantity') === 0) {
              propertiesToDelete.push(pair[0])
              propertiesToAppend.push({
                key: 'items[0][quantity]',
                value: pair[1],
              })
            }
          }
          propertiesToDelete.forEach((p) => {
            formData.delete(p)
          })
          propertiesToAppend.forEach((p) => {
            formData.append(p.key, p.value)
          })

          formData.append('items[1][id]', insiderClubUpsell.value)
          if (insiderClubUpsell.dataset.sellingPlan) {
            formData.append('items[1][selling_plan]', insiderClubUpsell.dataset.sellingPlan)
          }
          formData.append('items[1][quantity]', 1)
        }

        if (this.productInfo.dataset.isRebuyRecommendation === 'true') {
          formData.append('properties[_source]', 'Rebuy')
          formData.append('properties[_attribution]', 'Product Recommendations')
          formData.append('properties[_widget_id]', this.productInfo.dataset.ruleId)
        }
      }

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id),
        )
        formData.append('sections_url', window.location.pathname)
        this.cart.setActiveElement(document.activeElement)
      }

      config.body = formData

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add`, config)
        const data = await response.json()

        if (this.productInfo) {
          const bundleBuilderQuantitySelector = this.productInfo.querySelector(
            'bundle-builder-quantity-selector',
          )
          if (bundleBuilderQuantitySelector) {
            const select = bundleBuilderQuantitySelector.querySelector('select')
            if (select) {
              select.selectedIndex = 0
            }
          }
        }

        if (this.cart) {
          if (typeof data?.items === 'object' || data.sections === null) {
            // Multiple items added - trigger full cart refresh
            document.dispatchEvent(
              new CustomEvent('cartaddsuccess', {
                detail: {
                  openCart: true,
                },
              }),
            )
          } else {
            // Single item added
            CartPerformance.measure('add:paint-updated-sections', () => {
              this.cart.renderContents(data)
            })
          }

          const quickAddModal = document.querySelector('quick-modal')
          if (quickAddModal) {
            if (this.productInfo.dataset.pageType !== 'bundle builder') {
              quickAddModal.close()
            }
          }

          let cartSource
          if (this.productInfo.dataset.pdpType === 'popup') {
            cartSource = 'Quick View'
            if (this.productInfo.dataset.pageType === 'bundle builder') {
              cartSource = 'AMSM'
            }
          } else {
            cartSource = packSize === 'Single' ? 'PDP Singles' : 'PDP Curated Pack'
          }

          window.dataLayer = window.dataLayer || []
          dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            event: 'add_to_cart',
            cart_source: cartSource,
            membership_status: this.productInfo.dataset.membershipStatus,
            ...window.intelligemsMeta,
            userId: this.productInfo.dataset.customerId || null,
            page_type: this.productInfo.dataset.pageType,
            color_pack: this.productInfo.dataset.colorPack,
            login_status: this.productInfo.dataset.loginStatus,
            pack_quantity: this.productInfo.dataset.packQuantity,
            pdp_type: this.productInfo.dataset.pdpType,
            ecommerce: {
              currency: this.productInfo.dataset.ecommerceCurrency,
              value: Number(this.productInfo.dataset.productPrice),
              items: [
                {
                  item_id: Number(this.productInfo.dataset.productId),
                  item_name: this.productInfo.dataset.productTitle,
                  coupon: '',
                  discount: Number(this.productInfo.dataset.productDiscount),
                  index: 1,
                  cart_source: cartSource,
                  item_brand: this.productInfo.dataset.productBrand,
                  item_category: this.productInfo.dataset.productCategory,
                  item_category2: this.productInfo.dataset.productCategory2,
                  item_category3: Number(this.productInfo.dataset.productCategory3),
                  item_category4: this.productInfo.dataset.productCategory4,
                  item_category5: this.productInfo.dataset.productCategory5,
                  item_list_id: '',
                  item_list_name: '',
                  item_variant: this.productInfo.dataset.colorPack,
                  price: Number(this.productInfo.dataset.productPrice),
                  quantity: packSize === 'Single' ? Number(quantity) : 1,
                  style_number: this.productInfo.dataset.styleNumber
                    ? this.productInfo.dataset.styleNumber
                    : '',
                  sku_id: this.productInfo.dataset.sku ? this.productInfo.dataset.sku : '',
                  variant_id: this.productInfo.dataset.variantId
                    ? this.productInfo.dataset.variantId
                    : '',
                },
              ],
            },
          })
        }
        if (data.status === 422) {
          alert(data.message)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.submitButton.classList.remove('loading')
        if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty')
        if (!this.error) this.submitButton.removeAttribute('aria-disabled')
        this.querySelector('.loading__spinner').classList.add('hidden')
        this.isSubmitting = false
        document.dispatchEvent(new CustomEvent('cartupdatesuccess'))
      }
    }
  }
  customElements.define('product-form', ProductForm)
}
